import script from "./StatsCommunityFootprintQuery.vue?vue&type=script&lang=js"
export * from "./StatsCommunityFootprintQuery.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__